import { DETAILS_TENDER_UMUM, RESET_DETAILS_TENDER_UMUM, RESET_TABLES_TENDER_UMUM, TABLES_TENDER_UMUM } from "./tenderUmumTypes";

const initialState = {
    tables: {
        isLoading: false,
        data: [],
        currenPage: 1,
        pageSize: 10,
        totalData: 0
    },
    details: {
        isLoading: false,
        data: null
    }
}

const tenderUmumReducers = (state = initialState, action) => {
    let key, value;
    switch (action.type) {
        case TABLES_TENDER_UMUM:
            ({ key, value } = action.payload);
            const newTablesState = {
                ...state,
                tables: {
                    ...state.tables,
                    [key]: value
                }
            };
            return newTablesState;
        case RESET_TABLES_TENDER_UMUM:
            return {
                ...state,
                tables: {
                    isLoading: false,
                    data: [],
                    currenPage: 1,
                    pageSize: 10,
                    totalData: 0
                },
            };
        case DETAILS_TENDER_UMUM:
            ({ key, value } = action.payload);
            const newDetailsState = {
                ...state,
                details: {
                    ...state.details,
                    [key]: value
                }
            };
            return newDetailsState;
        case RESET_DETAILS_TENDER_UMUM:
            return {
                ...state,
                details: {
                    isLoading: false,
                    data: null
                }
            };
        default:
            return state;
    }
}

export default tenderUmumReducers;